import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import tick from '../../../../../../../assets/images/tick.svg';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-success.module.scss';
import Header from '../../../../../../../components/Stake/header';
import * as omV2StakeActions from '../../../../../../../actions/om-v2-stake-actions';
import { useShowOnlyOmV2 } from '../../../../../../../hooks/useShowOnlyOmV2';
import OmBlackIcon from '../../../../../../../assets/images/tokens/om-v2.svg';
import TxID from '../../../../../../../components/txID';

const WithdrawSuccess = () => {
  const dispatch = useDispatch();
  const showOnlyOmV2 = useShowOnlyOmV2();
  const tokenTitle = showOnlyOmV2 ? 'OM' : 'OM V2';
  const { id } = useSelector((state) => state.OMV2stake.stake);

  return (
    <>
      <Header icon={OmBlackIcon} title={`${tokenTitle}-Withdrawal`} />
      <div className={stylesParent.cardContent}>
        <div className={styles.icon}>
          <img src={tick} alt='' />
        </div>
        <div className={styles.status}>Withdrawn</div>
        <TxID id={id} />
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(omV2StakeActions.stakeReset())}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Done
          </Button>
        </div>
      </div>
    </>
  );
};

export default WithdrawSuccess;
